import type { TranscriptEntityType } from "@/types/transcript";

export const transcriptKeys = {
	all: ["transcripts"] as const,
	list: () => [...transcriptKeys.all, "list"] as const,
	detail: (id: string) => [...transcriptKeys.all, "detail", id] as const,
	forCandidate: (candidateId: string) => [...transcriptKeys.all, "candidate", candidateId] as const,
	entityOptions: (entity: TranscriptEntityType) => [...transcriptKeys.all, "options", entity] as const,
};
